module.exports = function getResource(label, vars = []) {
    let resources = {
        beautyServices: 'Beauty Services FAQ',
        happeningAtSephora: 'Happening at Sephora',
        makeupServices: 'Makeup Services'
    };

    return resources[label];
};
